// grid landscape style
import { SxProps } from "@mui/system";
import { ThemeV2 } from "../../util/types";

export const gridMainContainer = (theme: ThemeV2): SxProps => ({
  padding: { md: "20px 25px", sm: "10px 15px" },
  borderRadius: theme.tokens.shape.radius.lg,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  marginBottom: { sm: "30px" },
  marginX: 2,
});

export const gridTotalValueText = (
  theme: ThemeV2,
  inputValidColor?: boolean,
): SxProps => {
  return {
    color:
      /* c8 ignore start */

      !inputValidColor
        ? theme.tokens.color.feedback.error
        : theme.tokens.color.action.primary,
    /* c8 ignore end */
    fontWeight: theme.tokens.typography.weight.regular,
    textAlign: "center",
    fontSize: {
      md: theme.tokens.typography.size.xl,
      sm: theme.tokens.typography.size.sm,
      xs: theme.tokens.typography.size.xs,
    },
  };
};
export const columnsBottomTotoalValSemContainer = {
  display: "flex",
  width: "100%",
  justifyContent: "space-around",
};
export const rowsTotalValcontainer: SxProps = {
  height: "100%",
  display: "flex",
  flexDirection: "column",
  marginLeft: 2,
  alignItems: "center",
  justifySelf: "start",
};

export const columnsBottomTotalValContainer: SxProps = {
  display: "flex",
  alignItems: "center",
  minWidth: {
    xs: "max-content", // allow scroll on mobile
    sm: "max-content",
    md: "max-content", // fill container on medium screens
    lg: "max-content", // fill container on large screens
  },
  maxWidth: "100%", // prevent overflow on large screens
  paddingTop: 1,
};

export const bottomTotaltext: SxProps = {
  height: 50,
  display: "flex",
  alignItems: "flex-start",
  width: "100%",
  justifyContent: "end",
  paddingTop: 1,
};
export const totalText = (theme: ThemeV2): SxProps => {
  return {
    fontWeight: {
      md: theme.tokens.typography.weight.regular,
      xs: theme.tokens.typography.weight.medium,
    },
    fontSize: {
      md: theme.tokens.typography.size.xl,
      lg: theme.tokens.typography.size.lg,
      xs: theme.tokens.typography.size.xs,
    },
    color: theme.tokens.color.action.primary,
  };
};

/* c8 ignore next 2 */
export const textContainer = (height: number): SxProps => ({
  height: height > 0 ? height : "inherit",
  // minHeight: { md: 30, xs: 80 },
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
});

export const textWrapper: SxProps = {
  display: "flex",
  flexDirection: "column",
};

export const sendButtonWrapper: SxProps = {
  display: "flex",
  justifyContent: "flex-end",
  paddingRight: 1,
  paddingBottom: 3,
};

export const gridTemplateStyle: SxProps = {
  width: "100%",
  display: "grid",
  gridTemplateColumns: "auto auto auto",
  gap: 2,
  paddingX: { md: 3, xs: 1 },
  paddingY: { md: 2, xs: 2 },
};

export const columnsToplableCommonStyle = (
  theme: ThemeV2,
  rowIndex?: number,
): SxProps => {
  return {
    textAlign: "center",
    color: theme.tokens.color.action.primary,
    fontWeight: "300",
    fontSize: { sm: "16px", xs: "12px" },
    wordBreak: "normal",
    minWidth: { md: "100px", xs: "50px" },

    /* c8 ignore start */
    ...(rowIndex == 0
      ? { height: `100%`, opacity: 1 }
      : /* c8 ignore end */
        { height: 0, opacity: 0 }),
  };
};
